export const QUOTATION_UUID = 'a342d0d1-d2ff-4f57-b475-e7d5b45b5f7c';
export const QUOTATION_PATH = `/cotizaciones/${QUOTATION_UUID}`;
export const WHATSAPP_PHONE = '573118618245';
export const QUOTATION_LABEL = 'Cotizacion Transformadores Jamaica';

export const getQuotationAbsoluteUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${QUOTATION_PATH}`;
  }
  return QUOTATION_PATH;
};

export const getQuotationWhatsAppLink = (
  messagePrefix = 'Hola te contacto por la cotización de referencia'
) => {
  const referenceUrl = getQuotationAbsoluteUrl();
  const message = `${messagePrefix} ${referenceUrl}`.trim();
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodedMessage}`;
};
